import React, { useEffect, useState } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const ServiceTypes = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const [serviceTypes, setServiceTypes] = useState([])
  const [deleteId, setDeleteId] = useState("")
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [search, setSearch] = useState({ name: '' })
  const [checkedItems, setCheckedItems] = useState([])
  const [parentChecked, setParentChecked] = useState(false)
  const [load, setLoad] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])

  const fetchData = async () => {
    try {
      const response = await api.get("service-types")
      const data = Array.isArray(response.data.data) ? response.data.data : []
      setServiceTypes(data)
      setCheckedItems(new Array(data.length).fill(false))
    } catch (e) {
      console.error("Failed to load service types:", e)
    }
  }

  const fetchDelete = async () => {
    try {
      await api.delete("service-types/" + deleteId)
      setLoad(!load)
    } catch (e) {
      console.error("Delete failed:", e)
    }
  }

  const handleCheckboxChange = (i) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[i] = !newCheckedItems[i]
    setCheckedItems(newCheckedItems)
    setParentChecked(newCheckedItems.every((item) => item))
  }
  const handleParentCheckboxChange = () => {
    const newParentChecked = !parentChecked
    setParentChecked(newParentChecked)
    setCheckedItems(new Array(serviceTypes.length).fill(newParentChecked))
  }
  const removeFilter = () => {
    setSearch({ name: '' })
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="dashBody">
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Service Types</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-service-type">
                  <i className="fas fa-plus-square"></i> Add New
                </Link>
              )}
              <Link className="dashBtn" to="/service-items" style={{ marginLeft: 10 }}>
                <i className="fas fa-list"></i> Service Items
              </Link>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="serviceTypes">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, name: e.target.value})}
                    value={search.name} placeholder="Search by name" /></td>
                  <td></td><td></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply</a></td>
                </tr>
              )}
              {serviceTypes.length > 0 ? (
                serviceTypes.filter(item =>
                  (item.name || "").toLowerCase().includes(search.name.toLowerCase())
                ).map((st, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{st.name}</td>
                    <td>{st.description || '-'}</td>
                    <td>
                      <span className={`badge ${st.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                        {st.status}
                      </span>
                    </td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-service-type/" + st.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setDeleteId(st.id); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={6}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Service type deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default ServiceTypes
